<template>
	<v-container id="overviews" fluid >
		<!-- >>> The Data Table -------------------------------------------- -->
		<v-data-table
			v-model="selected"
			style="margin-bottom: 0px; margin-top: 0px;"
			:headers="headers"
			:items="get_Reports_Reports"
			:disable-pagination="true"
			:hide-default-footer="true"
			sort-by="id"
			:single-expand="singleExpand"
			:expanded.sync="expanded"
			show-expand
			class="elevation-1 data-table-custom-colors"
			@dblclick:row="(event, resourceItem) => onDblClick_DataTableRow(resourceItem.item)">

			<!-- >>> Expanded:Column -->
			<template v-slot:expanded-item="{ headers, item }">
				<td :colspan="headers.length">

					<!-- >>> Invoice Report 1 ------------------------------ -->
					<v-card v-if="item.id === 0" style="margin: 20px;">
						<v-card-title class="headline">
							<p class="pl-7 mb-8 mt-8">
								Search/Download: 'Invoice Report 1 - Months/Years' &check;
							</p>
						</v-card-title>

						<v-form>
							<!-- >>> Form, Fields -->
							<v-list>
								<!-- Field::'positions' -->
								<v-list-item>
									<v-combobox
										v-model="positions"
										:items="positionItems"
										label="Select one/more Position(s):"
										prepend-icon="mdi-account-multiple-plus"
										clearable
										multiple
										small-chips>
									</v-combobox>
								</v-list-item>

								<!-- Field::'months' -->
								<v-list-item class="mt-2">
									<v-icon style="margin-right:11px;margin-left:3px;margin-bottom:auto;margin-top:20px;">
										mdi-calendar
									</v-icon>
									<div style="width:100%;">
										<p style="color:rgba(0,0,0,.87);font-size:0.7rem;" class="ma-0 mb-n1 text-left">Select a Month:</p>
										<v-chip-group
											pre
											v-model="input_Months"
											active-class="sdr-chip--active">
											<v-chip small class="mx-1" v-for="month in items_Months" :key="month.text" :value="month.value">
												{{ month.text }}
											</v-chip>
										</v-chip-group>
										<v-divider class="mb-4 mt-1 grey lighten-1" />
									</div>
								</v-list-item>

								<!-- Field::'years' -->
								<v-list-item>
									<v-combobox
										v-model="years"
										:items="yearsItems"
										label="Select a Year:"
										prepend-icon="mdi-account-multiple-plus"
										clearable
										small-chips>
									</v-combobox>
								</v-list-item>
							</v-list>
							<!-- <<< Form, Fields -->


							<!-- >>> Action Buttons -->
							<v-card-actions style="padding-bottom:10px;">
								<v-spacer></v-spacer>
								<v-btn style="width:120px; font-size:16px;" depressed elevation="1" outlined color="#ab3b7a" @click="menu = false"> Cancel</v-btn>
								<v-btn style="width:120px; font-size:16px;" depressed elevation="1" color="primary" @click="onSubmit_Report_Invoice"> Download</v-btn>
							</v-card-actions>
							<!-- <<< Action Buttons -->
						</v-form>
					</v-card>


					<!-- >>> Invoice Report 2 ------------------------------ -->
					<v-card v-if="item.id === 1" style="margin: 20px;">
						<v-card-title class="headline">
							<p class="pl-7 mb-8 mt-8">
								Search/Download: 'Invoice Report 2 - From/To' &check;
							</p>
						</v-card-title>

						<v-form>
							<!-- >>> Form, Fields -->
							<v-list>
								<!-- Field::'positions' -->
								<v-list-item>
									<v-combobox
										v-model="positions"
										:items="positionItems"
										label="Select one/more Position(s):"
										prepend-icon="mdi-account-multiple-plus"
										clearable
										multiple
										small-chips>
									</v-combobox>
								</v-list-item>

								<!-- Field::'fromdate' -->
								<v-list-item>
									<v-menu
										ref="fromdatemenu_inv"
										v-model="fromdatemenu_inv"
										:close-on-content-click="false"
										:return-value.sync="fromdate_inv"
										transition="scale-transition"
										offset-y
										min-width="290px">
										<template v-slot:activator="{ on }">
											<v-text-field
												:value="computedFromDateFormattedMomentjs_Inv"
												ref = "fromdate_inv"
												label="Select a from Date:"
												prepend-icon="mdi-calendar-range"
												readonly
												v-on="on"
												class="mt-2">
											</v-text-field>
										</template>
										<v-date-picker v-model="fromdate_inv" no-title scrollable>
											<v-spacer></v-spacer>
											<v-btn text color="primary" @click="fromdatemenu_inv = false">Cancel</v-btn>
											<v-btn text color="primary" @click="onClick_AddDayToToDate_Inv(fromdate_inv)">OK</v-btn>
										</v-date-picker>
									</v-menu>
								</v-list-item>

								<!-- Field::'todate' -->
								<v-list-item>
									<v-menu
										ref="todatemenu_inv"
										v-model="todatemenu_inv"
										:close-on-content-click="false"
										:return-value.sync="todate_inv"
										transition="scale-transition"
										offset-y
										min-width="290px">
										<template v-slot:activator="{ on }">
											<v-text-field
												:value="computedToDateFormattedMomentjs_Inv"
												ref = "todate_inv"
												label="Select a to Date (+0):"
												prepend-icon="mdi-calendar-range"
												readonly
												v-on="on"
												class="mt-2">
											</v-text-field>
										</template>
										<v-date-picker v-model="todate_inv" no-title scrollable>
											<v-spacer></v-spacer>
											<v-btn text color="primary" @click="todatemenu_inv = false">Cancel</v-btn>
											<v-btn text color="primary" @click="$refs.todatemenu_inv.save(todate_inv)">OK</v-btn>
										</v-date-picker>
									</v-menu>
								</v-list-item>

							</v-list>
							<!-- <<< Form, Fields -->


							<!-- >>> Action Buttons -->
							<v-card-actions style="padding-bottom:10px;">
								<v-spacer></v-spacer>
								<v-btn style="width:120px; font-size:16px;" depressed elevation="1" outlined color="#ab3b7a" @click="menu = false"> Cancel</v-btn>
								<v-btn style="width:120px; font-size:16px;" depressed elevation="1" color="primary" @click="onSubmit_Report_Invoice2"> Download</v-btn>
							</v-card-actions>
							<!-- <<< Action Buttons -->
						</v-form>
					</v-card>


					<!-- >>> Missing Hotels & Co Report -------------------- -->
					<v-card v-if="item.id === 2" style="margin: 20px;">
						<v-card-title class="headline">
							<p class="pl-7 mb-8 mt-8">
								Search/Download: 'Missing Hotels & Proceeding Reports' &check;
							</p>
						</v-card-title>

						<v-form>
							<!-- >>> Form, Fields -->
							<v-list>
								<!-- Field::'errortypes' -->
								<v-list-item>
									<v-combobox
										v-model="errortypes"
										:items="errortypesItems"
										label="Select an Error Type:"
										multiple
										prepend-icon="mdi-account-multiple-plus"
										clearable
										small-chips>
									</v-combobox>
								</v-list-item>

								<!-- Field::'fromdate' -->
								<v-list-item>
									<v-menu
										ref="fromdatemenu_htl"
										v-model="fromdatemenu_htl"
										:close-on-content-click="false"
										:return-value.sync="fromdate_htl"
										transition="scale-transition"
										offset-y
										min-width="290px">
										<template v-slot:activator="{ on }">
											<v-text-field
												:value="computedFromDateFormattedMomentjs_Htl"
												ref = "fromdate_htl"
												label="Select a from Date:"
												prepend-icon="mdi-calendar-range"
												readonly
												v-on="on"
												class="mt-2">
											</v-text-field>
										</template>
										<v-date-picker v-model="fromdate_htl" no-title scrollable>
											<v-spacer></v-spacer>
											<v-btn text color="primary" @click="fromdatemenu_htl = false">Cancel</v-btn>
											<v-btn text color="primary" @click="onClick_AddDayToToDate_Htl(fromdate_htl)">OK</v-btn>
										</v-date-picker>
									</v-menu>
								</v-list-item>

								<!-- Field::'todate' -->
								<v-list-item>
									<v-menu
										ref="todatemenu_htl"
										v-model="todatemenu_htl"
										:close-on-content-click="false"
										:return-value.sync="todate_htl"
										transition="scale-transition"
										offset-y
										min-width="290px">
										<template v-slot:activator="{ on }">
											<v-text-field
												:value="computedToDateFormattedMomentjs_Htl"
												ref = "todate_htl"
												label="Select a to Date (+0):"
												prepend-icon="mdi-calendar-range"
												readonly
												v-on="on"
												class="mt-2">
											</v-text-field>
										</template>
										<v-date-picker v-model="todate_htl" no-title scrollable>
											<v-spacer></v-spacer>
											<v-btn text color="primary" @click="todatemenu_htl = false">Cancel</v-btn>
											<v-btn text color="primary" @click="$refs.todatemenu_htl.save(todate_htl)">OK</v-btn>
										</v-date-picker>
									</v-menu>
								</v-list-item>
							</v-list>
							<!-- <<< Form, Fields -->


							<!-- >>> Action Buttons -->
							<v-card-actions style="padding-bottom:10px;">
								<v-spacer></v-spacer>
								<v-btn style="width:120px; font-size:16px;" depressed elevation="1" outlined color="#ab3b7a" @click="menu = false"> Cancel</v-btn>
								<v-btn style="width:120px; font-size:16px;" depressed elevation="1" color="primary" @click="onSubmit_Report_MissingHotels"> Download</v-btn>
							</v-card-actions>
							<!-- <<< Action Buttons -->
						</v-form>
					</v-card>


					<!-- >>> Restriction Violation Report ------------------ -->
					<v-card v-if="item.id === 3" style="margin: 20px;">
						<v-card-title class="headline">
							<p class="pl-7 mb-8 mt-8">
								Search/Download: 'Restriction Violation Report' &check;
							</p>
						</v-card-title>

						<v-form>
							<!-- >>> Form, Fields -->
							<!-- <<< Form, Fields -->


							<!-- >>> Action Buttons -->
							<v-card-actions style="padding-bottom:10px;">
								<v-spacer></v-spacer>
								<v-btn style="width:120px; font-size:16px;" depressed elevation="1" outlined color="#ab3b7a" @click="menu = false"> Cancel</v-btn>
								<v-btn style="width:120px; font-size:16px;" depressed elevation="1" color="primary" @click="onSubmit_Report_RestrictionViolation"> Download</v-btn>
							</v-card-actions>
							<!-- <<< Action Buttons -->
						</v-form>
					</v-card>


					<!-- >>> Time Stats DT Report -------------------------- -->
					<v-card v-if="item.id === 5" style="margin: 20px;">
						<v-card-title class="headline">
							<p class="pl-7 mb-8 mt-8">
								Search/Download: 'Time Stats DT Report' &check;
							</p>
						</v-card-title>

						<v-form>
							<!-- >>> Form, Fields -->
							<v-list>
								<!-- Field::'years' -->
								<v-list-item>
									<v-combobox
										v-model="years"
										:items="yearsItems"
										label="Select a Year:"
										prepend-icon="mdi-account-multiple-plus"
										clearable
										small-chips>
									</v-combobox>
								</v-list-item>
							</v-list>
							<!-- <<< Form, Fields -->


							<!-- >>> Action Buttons -->
							<v-card-actions style="padding-bottom:10px;">
								<v-spacer></v-spacer>
								<v-btn style="width:120px; font-size:16px;" depressed elevation="1" outlined color="#ab3b7a" @click="menu = false"> Cancel</v-btn>
								<v-btn style="width:120px; font-size:16px;" depressed elevation="1" color="primary" @click="onSubmit_Report_TimeStats"> Download</v-btn>
							</v-card-actions>
							<!-- <<< Action Buttons -->
						</v-form>
					</v-card>


					<!-- >>> Time Stats FT Report -------------------------- -->
					<v-card v-if="item.id === 6" style="margin: 20px;">
						<v-card-title class="headline">
							<p class="pl-7 mb-8 mt-8">
								Search/Download: 'Time Stats FT Report' &check;
							</p>
						</v-card-title>

						<v-form>
							<!-- >>> Form, Fields -->
							<v-list>
								<!-- Field::'years' -->
								<v-list-item>
									<v-combobox
										v-model="years_ft"
										:items="years_ftItems"
										label="Select a Year:"
										prepend-icon="mdi-account-multiple-plus"
										clearable
										small-chips>
									</v-combobox>
								</v-list-item>
							</v-list>
							<!-- <<< Form, Fields -->


							<!-- >>> Action Buttons -->
							<v-card-actions style="padding-bottom:10px;">
								<v-spacer></v-spacer>
								<v-btn style="width:120px; font-size:16px;" depressed elevation="1" outlined color="#ab3b7a" @click="menu = false"> Cancel</v-btn>
								<v-btn style="width:120px; font-size:16px;" depressed elevation="1" color="primary" @click="onSubmit_Report_TimeStats_FT"> Download</v-btn>
							</v-card-actions>
							<!-- <<< Action Buttons -->
						</v-form>
					</v-card>


					<!-- >>> Flights with Crews Report --------------------- -->
					<v-card v-if="item.id === 7" style="margin: 20px;">
						<v-card-title class="headline">
							<p class="pl-7 mb-8 mt-8">
								Search/Download: 'Flights With Crews Report' &check;
							</p>
						</v-card-title>

						<v-form>
							<!-- >>> Form, Fields -->
							<v-list>
								<!-- Field::'fromdate' -->
								<v-list-item>
									<v-menu
										ref="fromdatemenu_fwc"
										v-model="fromdatemenu_fwc"
										:close-on-content-click="false"
										:return-value.sync="fromdate_fwc"
										transition="scale-transition"
										offset-y
										min-width="290px">
										<template v-slot:activator="{ on }">
											<v-text-field
												:value="computedFromDateFormattedMomentjs_Fwc"
												ref = "fromdate_fwc"
												label="Select a from Date:"
												prepend-icon="mdi-calendar-range"
												readonly
												v-on="on"
												class="mt-2">
											</v-text-field>
										</template>
										<v-date-picker v-model="fromdate_fwc" no-title scrollable>
											<v-spacer></v-spacer>
											<v-btn text color="primary" @click="fromdatemenu_fwc = false">Cancel</v-btn>
											<v-btn text color="primary" @click="onClick_AddDayToToDate_Fwc(fromdate_fwc)">OK</v-btn>
										</v-date-picker>
									</v-menu>
								</v-list-item>

								<!-- Field::'todate' -->
								<v-list-item>
									<v-menu
										ref="todatemenu_fwc"
										v-model="todatemenu_fwc"
										:close-on-content-click="false"
										:return-value.sync="todate"
										transition="scale-transition"
										offset-y
										min-width="290px">
										<template v-slot:activator="{ on }">
											<v-text-field
												:value="computedToDateFormattedMomentjs_Fwc"
												ref = "todate_fwc"
												label="Select a to Date (+0):"
												prepend-icon="mdi-calendar-range"
												readonly
												v-on="on"
												class="mt-2">
											</v-text-field>
										</template>
										<v-date-picker v-model="todate_fwc" no-title scrollable>
											<v-spacer></v-spacer>
											<v-btn text color="primary" @click="todatemenu_fwc = false">Cancel</v-btn>
											<v-btn text color="primary" @click="$refs.todatemenu_fwc.save(todate_fwc)">OK</v-btn>
										</v-date-picker>
									</v-menu>
								</v-list-item>
							</v-list>
							<!-- <<< Form, Fields -->


							<!-- >>> Action Buttons -->
							<v-card-actions style="padding-bottom:10px;">
								<v-spacer></v-spacer>
								<v-btn style="width:120px; font-size:16px;" depressed elevation="1" outlined color="#ab3b7a" @click="menu = false"> Cancel</v-btn>
								<v-btn style="width:120px; font-size:16px;" depressed elevation="1" color="primary" @click="onSubmit_Report_CrewsWithFlights"> Download</v-btn>
							</v-card-actions>
							<!-- <<< Action Buttons -->
						</v-form>
					</v-card>


					<!-- >>> Crew Infos on Flight Report ------------------- -->
					<v-card v-if="item.id === 8" style="margin: 20px;">
						<v-card-title class="headline">
							<p class="pl-7 mb-8 mt-8">
								Search/Download: 'Crew Infos on Flight Report' &check;
							</p>
						</v-card-title>

						<v-form>
							<!-- >>> Form, Fields -->
							<v-list>
								<!-- Field::'fromdate' -->
								<v-list-item>
									<v-menu
										ref="fromdatemenu"
										v-model="fromdatemenu"
										:close-on-content-click="false"
										:return-value.sync="fromdate"
										transition="scale-transition"
										offset-y
										min-width="290px">
										<template v-slot:activator="{ on }">
											<v-text-field
												:value="computedFromDateFormattedMomentjs"
												ref = "fromdate"
												label="Select a from Date:"
												prepend-icon="mdi-calendar-range"
												readonly
												v-on="on"
												class="mt-2">
											</v-text-field>
										</template>
										<v-date-picker v-model="fromdate" no-title scrollable>
											<v-spacer></v-spacer>
											<v-btn text color="primary" @click="fromdatemenu = false">Cancel</v-btn>
											<v-btn text color="primary" @click="$refs.fromdatemenu.save(fromdate)">OK</v-btn>
										</v-date-picker>
									</v-menu>
								</v-list-item>

								<!-- Field::'todate' -->
								<v-list-item>
									<v-menu
										ref="todatemenu"
										v-model="todatemenu"
										:close-on-content-click="false"
										:return-value.sync="todate"
										transition="scale-transition"
										offset-y
										min-width="290px">
										<template v-slot:activator="{ on }">
											<v-text-field
												:value="computedToDateFormattedMomentjs"
												ref = "todate"
												label="Select a to Date (+0):"
												prepend-icon="mdi-calendar-range"
												readonly
												v-on="on"
												class="mt-2">
											</v-text-field>
										</template>
										<v-date-picker v-model="todate" no-title scrollable>
											<v-spacer></v-spacer>
											<v-btn text color="primary" @click="todatemenu = false">Cancel</v-btn>
											<v-btn text color="primary" @click="$refs.todatemenu.save(todate)">OK</v-btn>
										</v-date-picker>
									</v-menu>
								</v-list-item>
							</v-list>
							<!-- <<< Form, Fields -->


							<!-- >>> Action Buttons -->
							<v-card-actions style="padding-bottom:10px;">
								<v-spacer></v-spacer>
								<v-btn style="width:120px; font-size:16px;" depressed elevation="1" outlined color="#ab3b7a" @click="menu = false"> Cancel</v-btn>
								<v-btn style="width:120px; font-size:16px;" depressed elevation="1" color="primary" @click="onSubmit_Report_CrewsInfosOnWithFlight"> Download</v-btn>
							</v-card-actions>
							<!-- <<< Action Buttons -->
						</v-form>
					</v-card>


					<!-- >>> Base Report -------------------------- Flyair41 -->
					<v-card v-if="item.id === 9" style="margin: 20px;">
						<v-card-title class="headline">
							<p class="pl-7 mb-8 mt-8">
								Search/Download: 'Base Report'  &check;
							</p>
						</v-card-title>

						<v-form>
							<!-- >>> Form, Fields -->
							<v-list>
								<!-- Field::'fromdate' -->
								<v-list-item>
									<v-menu
										ref="fromdatemenubasereport"
										v-model="fromdatemenubasereport"
										:close-on-content-click="false"
										:return-value.sync="fromdatebasereport"
										transition="scale-transition"
										offset-y
										min-width="290px">
										<template v-slot:activator="{ on }">
											<v-text-field
												:value="computedFromDateFormattedMomentjs"
												ref = "fromdatemenubasereport"
												label="Select a from Date:"
												prepend-icon="mdi-calendar-range"
												readonly
												v-on="on"
												class="mt-2">
											</v-text-field>
										</template>
										<v-date-picker v-model="fromdate" no-title scrollable>
											<v-spacer></v-spacer>
											<v-btn text color="primary" @click="fromdatemenubasereport = false">Cancel</v-btn>
											<v-btn text color="primary" @click="fromdatemenubasereport = false">OK</v-btn>
										</v-date-picker>
									</v-menu>
								</v-list-item>
							</v-list>
							<!-- <<< Form, Fields -->


							<!-- >>> Action Buttons -->
							<v-card-actions style="padding-bottom:10px;">
								<v-spacer></v-spacer>
								<v-btn style="width:120px; font-size:16px;" depressed elevation="1" outlined color="#ab3b7a" @click="menu = false"> Cancel</v-btn>
								<v-btn style="width:120px; font-size:16px;" depressed elevation="1" color="primary" @click="onSubmit_Report_Base"> Download</v-btn>
							</v-card-actions>
							<!-- <<< Action Buttons -->
						</v-form>
					</v-card>
				</td>
			</template>
			<!-- <<< Expanded:Column -->
		</v-data-table>
		<!-- <<< The Data Table -------------------------------------------- -->




		<!-- >>> Sdr-Component, BottomSheet -------------------------------- -->
		<sdr-invoice-report-bottom-sheet
			v-model="showSheet"
			:editorMode="editorMode"
			:resourcePrefillObject="resourcePrefillObject">
		</sdr-invoice-report-bottom-sheet>
		<!-- <<< Sdr-Component, BottomSheet -------------------------------- -->
	</v-container>
</template>
<script>
	import Vue from 'vue';

	import InvoiceReportBottomSheet from './components/core/BottomSheet.vue';

	import { mapGetters, mapActions } from 'vuex';
    import moment from 'moment';
	import dayjs from "dayjs";
	import utc from 'dayjs/plugin/utc';


	export default {
		name: 'InvoiceReportHome',

		/* >>> *************************************************************** / /* Components */
		components: {

			'sdr-invoice-report-bottom-sheet': InvoiceReportBottomSheet

		}, // eo components{}
		/* <<< ****************************************************************/



		/* >>> *************************************************************** / /* Data */
		data: function() {

			return {
				// >>> Data Table Header ------------------
				headers : [
					{ text: 'List of Report(s)', value: 'title', class: 'sticky-header grey lighten-3' },
					{ text: '', value: 'data-table-expand', class: 'sticky-header grey lighten-3' },
				],
				// >>> ------------------------------------
				// >>> ------------------------------------
				expanded: [],
				singleExpand: true,
                // >>> ------------------------------------ Tables Checkboxes
                singleSelect: false,
                selected: [],
				// >>> ------------------------------------
				showSheet : false,
				editorMode : null, // 'update, create'
				resourcePrefillObject : null,
				// >>> ------------------------------------
				showConfirmDeleteDialog: false,
				resourceIdToDelete: null,
				// >>> ------------------------------------
				showConfirmSwitchActiveInactiveDialog: false,
				resourceIdToSwitchActiveInactive: null,
				resourceNameToSwitchActiveInactive: '',
				switchActiveInactive_StatusToSwitchTo: '',
				// >>> ------------------------------------
				// >>> ------------------------------------
				// >>> ------------------------------------ 2
                positions: null,
                positionItems: [
                    'CP',
                    'FO',
                    'SCCM',
                    'CA',
                ],
				fromdate_inv: new Date().toISOString().substr(0, 10),
				fromdatemenu_inv: false,
				todate_inv: new Date(new Date().getTime()).toISOString().substr(0, 10), // new Date().toISOString().substr(0, 10),
				todatemenu_inv: false,

				// >>> ------
				fromdate: new Date().toISOString().substr(0, 10),
				fromdatemenu: false,
				// todate: new Date(new Date().getTime()+(31*24*60*60*1000)).toISOString().substr(0, 10), // new Date().toISOString().substr(0, 10),
				todate: new Date(new Date().getTime()).toISOString().substr(0, 10), // new Date().toISOString().substr(0, 10),
				todatemenu: false,
				// >>> ------
                input_Months: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
                items_Months: [
                    { text: 'Jan', value: 1 },
                    { text: 'Feb', value: 2 },
                    { text: 'Mar', value: 3 },
                    { text: 'Apr', value: 4 },
                    { text: 'May', value: 5 },
                    { text: 'Jun', value: 6 },
                    { text: 'Jul', value: 7 },
                    { text: 'Aug', value: 8 },
                    { text: 'Sep', value: 9 },
                    { text: 'Oct', value: 10 },
                    { text: 'Nov', value: 11 },
                    { text: 'Dec', value: 12 },
                ],
				// >>> ------
                years_ft: null,
                years_ftItems: [
					'2024',
                    '2023',
                    '2022',
                    '2021',
                    '2020',
                    '2019',
                    '2018',
                    '2017',
                    '2016',
                    '2015',
                ],
				years: null,
                yearsItems: [
					'2024',
                    '2023',
                    '2022',
                    '2021',
                    '2020',
                    '2019',
                    '2018',
                    '2017',
                    '2016',
                    '2015',
                ],
				// >>> ------------------------------------ 2
                errortypes: null,
                errortypesItems: [
                    'HOTEL',
                    'PROCEEDING',
                    'UNKNOWN AIRPORT',
                ],
				fromdate_htl: new Date().toISOString().substr(0, 10),
				fromdatemenu_htl: false,
				todate_htl: new Date(new Date().getTime()).toISOString().substr(0, 10), // new Date().toISOString().substr(0, 10),
				todatemenu_htl: false,

				// >>> ------ flyair41
				fromdatebasereport: new Date().toISOString().substr(0, 10),
				fromdatemenubasereport: false,

				// >>> ------------------------------------ 6
				fromdate_fwc: new Date().toISOString().substr(0, 10),
				fromdatemenu_fwc: false,
				todate_fwc: new Date(new Date().getTime()).toISOString().substr(0, 10), // new Date().toISOString().substr(0, 10),
				todatemenu_fwc: false,

			}

		}, // eo function data()
		/* <<< ****************************************************************/



		/* >>> *************************************************************** / /* Computed */
		computed: {

			...mapGetters([
				'get_Reports_Reports',
				'get_Shared_AuthHeader',
			]),


            /*******************************************************************
            * computedFromDateFormattedMomentjs()
            *
            * Desc:
            * Note:
            *
            */
            computedFromDateFormattedMomentjs () {

                return this.fromdate ? moment(this.fromdate).format('YYYY-MM-DD') : ''; // dddd, MMMM Do YYYY

            }, // eo function computedFromDateFormattedMomentjs()


            /*******************************************************************
            * computedToDateFormattedMomentjs()
            *
            * Desc:
            * Note:
            *
            */
            computedToDateFormattedMomentjs () {

                return this.todate ? moment(this.todate).format('YYYY-MM-DD') : ''; // .add(31, 'd')

            }, // eo function computedToDateFormattedMomentjs()


            /*******************************************************************
            * computedFromDateFormattedMomentjs_Fwc()
            *
            * Desc:
            * Note:
            *
            */
            computedFromDateFormattedMomentjs_Fwc () {

                return this.fromdate_fwc ? moment(this.fromdate_fwc).format('YYYY-MM-DD') : ''; // dddd, MMMM Do YYYY

            }, // eo function computedFromDateFormattedMomentjs_Fwc()


            /*******************************************************************
            * computedToDateFormattedMomentjs_Fwc()
            *
            * Desc:
            * Note:
            *
            */
            computedToDateFormattedMomentjs_Fwc () {

                return this.todate_fwc ? moment(this.todate_fwc).format('YYYY-MM-DD') : ''; // .add(31, 'd')

            }, // eo function computedToDateFormattedMomentjs_Fwc()


            /*******************************************************************
            * computedFromDateFormattedMomentjs_Htl()
            *
            * Desc:
            * Note:
            *
            */
            computedFromDateFormattedMomentjs_Htl() {

                return this.fromdate_htl ? moment(this.fromdate_htl).format('YYYY-MM-DD') : ''; // dddd, MMMM Do YYYY

            }, // eo function computedFromDateFormattedMomentjs_Htl()


            /*******************************************************************
            * computedToDateFormattedMomentjs_Htl()
            *
            * Desc:
            * Note:
            *
            */
            computedToDateFormattedMomentjs_Htl() {

                return this.todate_htl ? moment(this.todate_htl).format('YYYY-MM-DD') : ''; // .add(31, 'd')

            }, // eo function computedToDateFormattedMomentjs_Htl()


            /*******************************************************************
            * computedFromDateFormattedMomentjs_Inv()
            *
            * Desc:
            * Note:
            *
            */
            computedFromDateFormattedMomentjs_Inv() {

                return this.fromdate_inv ? moment(this.fromdate_inv).format('YYYY-MM-DD') : ''; // dddd, MMMM Do YYYY

            }, // eo function computedFromDateFormattedMomentjs_Inv()


            /*******************************************************************
            * computedToDateFormattedMomentjs_Inv()
            *
            * Desc:
            * Note:
            *
            */
            computedToDateFormattedMomentjs_Inv() {

                return this.todate_inv ? moment(this.todate_inv).format('YYYY-MM-DD') : ''; // .add(31, 'd')

            }, // eo function computedToDateFormattedMomentjs_Inv()

		}, // eo computed{}
		/* <<< ****************************************************************/



		/* >>> *************************************************************** / /* Methods */
		methods: {

			...mapActions([
				'actn_call_download_InvoiceReport',
				'actn_call_download_TimeStatsReport',
				'actn_call_download_TimeStatsReport_FT',
				'actn_call_download_RestrictionViolationReport',
				'actn_call_download_MissingHotelsReport',
				'actn_call_download_BaseReport', // Flyair41
				'actn_call_download_CrewWithFlightsReport',
				'actn_call_download_CrewInfosOnFlightsReport',
			]),


            /******************************************************************* 'Listeners'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onSubmit_Report_Invoice()
            *
            * Desc: Validate 'Invoice Report' Form.
            * Note:
            *
            */
            onSubmit_Report_Invoice: function() {

                let me = this,
					params = {
						month: null,
						position: [],
						year: null
					};


				me.$toc('>>> views/reports/summary/Home.vue >>> onSubmit_Report_Invoice');
				if (this.onValidate_Report_Invoice() === true) {
					params.month = this.input_Months;
					params.position = Array.isArray(this.positions) && this.positions.length ? this.positions : null;
					params.year = +this.years;

					this.actn_call_download_InvoiceReport({ params: params, authheader: this.get_Shared_AuthHeader });
				}

            }, // eo function onSubmit_Report_Invoice()


            /*******************************************************************
            * onSubmit_Report_Invoice2()
            *
            * Desc: Validate 'Invoice Report' Form. 2
            * Note:
            *
            */
            onSubmit_Report_Invoice2: function() {

                let me = this,
					params = {
						month: null,
						position: [],
						year: null,
						fromDate: dayjs(this.fromdate_inv).format('YYYY-MM-DDT00:00:00'),
						toDate: dayjs(this.todate_inv).format('YYYY-MM-DDT23:59:59'),
					};


				me.$toc('>>> views/reports/summary/Home.vue >>> onSubmit_Report_Invoice2');
				// if (this.onValidate_Report_Invoice() === true) {
					// params.month = this.input_Months;
					params.position = Array.isArray(this.positions) && this.positions.length ? this.positions : null;
					// params.year = +this.years;

					this.actn_call_download_InvoiceReport({ params: params, authheader: this.get_Shared_AuthHeader });
				// }

            }, // eo function onSubmit_Report_Invoice2()


            /*******************************************************************
            * onSubmit_Report_TimeStats()
            *
            * Desc: Validate 'Time Stats Report' Form. (DT)
            * Note:
            *
            */
            onSubmit_Report_TimeStats: function() {

                let me = this,
					params = {
						year: null
					};


				me.$toc('>>> views/reports/summary/Home.vue >>> onSubmit_Report_MissingHotels');
				if (this.onValidate_Report_TimeStats() === true) {
					params.year = +this.years;

					this.actn_call_download_TimeStatsReport({ params: params, authheader: this.get_Shared_AuthHeader });
				}

            }, // eo function onSubmit_Report_TimeStats()



            /*******************************************************************
            * onSubmit_Report_TimeStats_FT()
            *
            * Desc: Validate 'Time Stats Report' Form. (FT)
            * Note:
            *
            */
            onSubmit_Report_TimeStats_FT: function() {

                let me = this,
					params = {
						year: null
					};


				me.$toc('>>> views/reports/summary/Home.vue >>> onSubmit_Report_TimeStats_FT');
				if (this.onValidate_Report_TimeStats_FT() === true) {
					params.year = +this.years_ft;

					this.actn_call_download_TimeStatsReport_FT({ params: params, authheader: this.get_Shared_AuthHeader });
				}

            }, // eo function onSubmit_Report_TimeStats_FT()


            /*******************************************************************
            * onSubmit_Report_RestrictionViolation()
            *
            * Desc: Validate 'Restriction Violation report' Form.
            * Note:
            *
            */
            onSubmit_Report_RestrictionViolation: function() {

                let me = this;


				me.$toc('>>> views/reports/summary/Home.vue >>> onSubmit_Report_RestrictionViolation');
				this.actn_call_download_RestrictionViolationReport({ authheader: this.get_Shared_AuthHeader });

            }, // eo function onSubmit_Report_RestrictionViolation()


            /*******************************************************************
            * onSubmit_Report_MissingHotels()
            *
            * Desc: Validate 'Time Stats Report' Form.
            * Note:
            *
            */
            onSubmit_Report_MissingHotels: function() {

                let me = this,
					params = {
						filter: null,
						fromDate: dayjs(this.fromdate_htl).format('YYYY-MM-DDT00:00:00'),
						toDate: dayjs(this.todate_htl).format('YYYY-MM-DDT23:59:59'),
					};


				me.$toc('>>> views/reports/summary/Home.vue >>> onSubmit_Report_MissingHotels');
				params.filter = this.errortypes;
				this.actn_call_download_MissingHotelsReport({ params: params, authheader: this.get_Shared_AuthHeader });

            }, // eo function onSubmit_Report_MissingHotels()


           	/******************************************************************* // Flyair41
            * onSubmit_Report_Base()
            *
            * Desc: Validate 'Time Stats Report' Form.
            * Note:
            *
            */
            onSubmit_Report_Base: function() {

                let me = this,
					params = {
						date: null
					};


				me.$toc('>>> views/reports/summary/Home.vue >>> onSubmit_Report_Base');
				params.date = dayjs(this.fromdatebasereport).format('YYYY-MM-DDT23:59:59');
				this.actn_call_download_BaseReport({ params: params, authheader: this.get_Shared_AuthHeader });

            }, // eo function onSubmit_Report_Base()


           	/*******************************************************************
            * onSubmit_Report_CrewsWithFlights()
            *
            * Desc:
            * Note:
            *
            */
            onSubmit_Report_CrewsWithFlights: function() {

                let me = this,
					params = {
						fromDate: dayjs(this.fromdate_fwc).format('YYYY-MM-DDT00:00:00'),
						toDate: dayjs(this.todate_fwc).format('YYYY-MM-DDT23:59:59'),
						slot: false,
						showSlots: false,
					};


				me.$toc('>>> views/reports/summary/Home.vue >>> onSubmit_Report_CrewsWithFlights');
				this.actn_call_download_CrewWithFlightsReport({ params: params, authheader: this.get_Shared_AuthHeader });

            }, // eo function onSubmit_Report_CrewsWithFlights()


           	/*******************************************************************
            * onSubmit_Report_CrewsInfosOnWithFlight()
            *
            * Desc:
            * Note:
            *
            */
            onSubmit_Report_CrewsInfosOnWithFlight: function() {

                let me = this,
					params = {
						fromDate: dayjs(this.fromdate).format('YYYY-MM-DDT00:00:00'),
						toDate: dayjs(this.todate).format('YYYY-MM-DDT23:59:59'),
					};


				me.$toc('>>> views/reports/summary/Home.vue >>> onSubmit_Report_CrewsInfosOnWithFlight');
				this.actn_call_download_CrewInfosOnFlightsReport({ params: params, authheader: this.get_Shared_AuthHeader });

            }, // eo function onSubmit_Report_CrewsInfosOnWithFlight()




            /*******************************************************************
            * onClick_AddDayToToDate()
            *
            * Desc: Add 31 Day to 'todate' on changing 'fromdate'.
            * Note: Before it was '$refs.fromdatemenu.save(fromdate)'
            *
            */
            onClick_AddDayToToDate: function(fromdate) {

                let me = this;


				me.$toc('>>> views/reports/summary/Home.vue >>> onClick_AddDayToToDate');
				return;
                this.$refs.fromdatemenu.save(fromdate); // save
                this.todate = new Date(new Date(fromdate).getTime()+(31*24*60*60*1000)).toISOString().substr(0, 10); // add

            }, // eo function onClick_AddDayToToDate()


            /*******************************************************************
            * onClick_AddDayToToDate_Fwc()
            *
            * Desc: Add 31 Day to 'todate_fwc' on changing 'fromdate_fwc'.
            * Note: Before it was '$refs.fromdatemenu.save(fromdate)'
            *
            */
            onClick_AddDayToToDate_Fwc: function(fromdate_fwc) {

                let me = this;


				me.$toc('>>> views/reports/summary/Home.vue >>> onClick_AddDayToToDate_Fwc');
                this.$refs.fromdatemenu_fwc.save(fromdate_fwc); // save
                this.todate_fwc = new Date(new Date(fromdate_fwc).getTime()).toISOString().substr(0, 10); // add

            }, // eo function onClick_AddDayToToDate_Fwc()


            /*******************************************************************
            * onClick_AddDayToToDate_Htl()
            *
            * Desc: Add 31 Day to 'todate_fwc' on changing 'fromdate_fwc'.
            * Note: Before it was '$refs.fromdatemenu.save(fromdate)'
            *
            */
            onClick_AddDayToToDate_Htl: function(fromdate_htl) {

                let me = this;


				me.$toc('>>> views/reports/summary/Home.vue >>> onClick_AddDayToToDate_Htl');
                this.$refs.fromdatemenu_htl.save(fromdate_htl); // save
                this.todate_htl = new Date(new Date(fromdate_htl).getTime()).toISOString().substr(0, 10); // add

            }, // eo function onClick_AddDayToToDate_Htl()


            /*******************************************************************
            * onClick_AddDayToToDate_Inv()
            *
            * Desc: Add 31 Day to 'todate_fwc' on changing 'fromdate_fwc'.
            * Note: Before it was '$refs.fromdatemenu.save(fromdate)'
            *
            */
            onClick_AddDayToToDate_Inv: function(fromdate_inv) {

                let me = this;


				me.$toc('>>> views/reports/summary/Home.vue >>> onClick_AddDayToToDate_Inv');
                this.$refs.fromdatemenu_inv.save(fromdate_inv); // save
                this.todate_inv = new Date(new Date(fromdate_inv).getTime()).toISOString().substr(0, 10); // add

            }, // eo function onClick_AddDayToToDate_Inv()


			/*******************************************************************
			* onDblClick_DataTableRow()
			*
			* Desc:
			* Note:
			*
			*/
			onDblClick_DataTableRow: function(resourceItem) {

				let me = this;


				me.$toc('>>> views/reports/summary/Home.vue >>> onDblClick_DataTableRow');


			}, // eo function onDblClick_DataTableRow()




			/******************************************************************* 'Forms Validations'
            * Forms Validations:
            *******************************************************************/
            /*******************************************************************
            * onValidate_Report_Invoice()
            *
            * Desc: Validate 'Invoice Report' Form.
            * Note:
            *
            */
            onValidate_Report_Invoice: function() {

                let me = this,
					isValid = true;


				me.$toc('>>> views/reports/summary/Home.vue >>> onValidate_Report_Invoice');
				// >>> 'position' -------------------------
				// if (this.positions === undefined || this.positions === 0 || this.positions === null) {
				// 	Vue.prototype.$toasted.global.sdr_app_error({
				// 		message: "Select a Position in 'Invoice Report'"
				// 	});
				// 	isValid = false;
				// }

				// >>> 'month' -------------------------
				if (isValid) {
					if (this.input_Months === undefined || typeof this.input_Months !== 'number') {
						Vue.prototype.$toasted.global.sdr_app_error({
							message: "Select a Month in 'Invoice Report'"
						});
						isValid = false;
					}
				}

				// >>> 'year' -------------------------
				if (isValid) {
					if (this.years === undefined || this.years === 0 || this.years === null) {
						Vue.prototype.$toasted.global.sdr_app_error({
							message: "Select a Year in 'Invoice Report'"
						});
						isValid = false;
					}
				}


				return isValid;

            }, // eo function onValidate_Report_Invoice()


            /*******************************************************************
            * onValidate_Report_TimeStats()
            *
            * Desc: Validate 'Time Stats Report' Form.
            * Note:
            *
            */
            onValidate_Report_TimeStats: function() {

                let me = this,
					isValid = true;


				me.$toc('>>> views/reports/summary/Home.vue >>> onValidate_Report_TimeStats');
				// >>> 'year' -------------------------
				if (this.years === undefined || this.years === 0 || this.years === null) {
					Vue.prototype.$toasted.global.sdr_app_error({
						message: "Select a Year in 'Invoice Report'"
					});
					isValid = false;
				}


				return isValid;

            }, // eo function onValidate_Report_TimeStats()

            /*******************************************************************
            * onValidate_Report_TimeStats_FT()
            *
            * Desc: Validate 'Time Stats Report' Form. (FT)
            * Note:
            *
            */
            onValidate_Report_TimeStats_FT: function() {

                let me = this,
					isValid = true;


				me.$toc('>>> views/reports/summary/Home.vue >>> onValidate_Report_TimeStats_FT');
				// >>> 'year' -------------------------
				if (this.years_ft === undefined || this.years_ft === 0 || this.years_ft === null) {
					Vue.prototype.$toasted.global.sdr_app_error({
						message: "Select a Year in 'Invoice Report'"
					});
					isValid = false;
				}


				return isValid;

            }, // eo function onValidate_Report_TimeStats_FT()

		} // eo methods{}
		/* <<< ****************************************************************/
	};
</script>

<style scoped>
	.v-data-table /deep/ .sticky-header {
		position: sticky;
		top: 65px;
		z-index: 1;
	}

	.v-data-table /deep/ .v-data-table__wrapper {
		margin-top: 0px;
		overflow: unset;
	}

	.v-data-table /deep/ tr:nth-child(2n) {
		background-color: #FAFAFA;
	}

	.v-chip__content {
		font-size: 12px;
	}

	.rowWasEdited {
		/* border-left: 4px solid #AB3B7C;
		padding-left: 4px; */
		/* background-color: #AB3B7C; */
		border: 2px solid #AB3B7C;
		padding: 2px;

	}
</style>

<style>

	.v-application .text-start {
		text-align: start !important;
		font-weight: 500;
	}


	.smaller-column {
		width: 5%;
	}

	.v-data-table /deep/ thead tr th {
		background-color: red !important;
	}

	.v-data-table table thead tr th {
		font-size: 15px;
	}





    .v-select.v-select--chips.v-select--chips--small .v-select__selections {
        min-height: 0px !important; /* 26px */
    }

    .v-label {
        font-size: 14px !important; /* 16px */
    }

    .v-select.v-select--chips input {
        min-height: 42px;
    }

    .v-btn__content {
        font-size: 12px;
    }

    .v-card {
        margin-top: 0px;
        margin-bottom: 0px;
    }




	.sdr-chip--active {
		background: #ab3b7a;
		color: white !important;
	}



	.v-data-table table thead tr th {
		font-size: 19px !important;
	}




	.v-data-table td {
		font-size: 15px;
		height: 58px;
	}
</style>